import {SolicitudCreditoEstado} from './solicitud-credito-estado';

export class Fraccionamiento {
  id: number;
  comercio: string;
  cliente: string;
  nombre: string;
  apellido: string;
  codigoCliente: string;
  estadoSolicitud: SolicitudCreditoEstado;
  numeroSolicitud: string;
  montoSolicitado: string;
  plazoMeses: string;
  importeCuota: string;
  mensajeAprobadoRechazado: string;
  montoDesembolsado: string;
  fechaSolicitud: string;
  colorEstadoSolicitud: string;

  constructor(id?: number, comercio?: string, cliente?: string, nombre?: string, apellido?: string, codigoCliente?: string,
              estadoSolicitud?: SolicitudCreditoEstado, numeroSolicitud?: string, montoSolicitado?: string,
              plazoMeses?: string, importeCuota?: string, mensajeAprobadoRechazado?: string,
              montoDesembolsado?: string, fechaSolicitud?: string, colorEstadoSolicitud?: string) {
    this.id = id ?? null;
    this.comercio = comercio ?? '';
    this.cliente = cliente ?? '';
    this.nombre = nombre ?? '';
    this.apellido = apellido ?? '';
    this.codigoCliente = codigoCliente ?? '';
    this.estadoSolicitud = estadoSolicitud ?? new SolicitudCreditoEstado();
    this.numeroSolicitud = numeroSolicitud ?? '';
    this.montoSolicitado = montoSolicitado ?? '';
    this.plazoMeses = plazoMeses ?? '';
    this.importeCuota = importeCuota ?? '';
    this.mensajeAprobadoRechazado = mensajeAprobadoRechazado ?? '';
    this.montoDesembolsado = montoDesembolsado ?? '';
    this.fechaSolicitud = fechaSolicitud ?? '';
    this.colorEstadoSolicitud= colorEstadoSolicitud ?? '';
  }
}
